import { render } from "./WizardDrawer.vue?vue&type=template&id=1be1756e&scoped=true&ts=true"
import script from "./WizardDrawer.vue?vue&type=script&lang=ts"
export * from "./WizardDrawer.vue?vue&type=script&lang=ts"

import "./WizardDrawer.vue?vue&type=style&index=0&id=1be1756e&scoped=true&lang=scss"

import exportComponent from "/home/ubuntu/workspace/OneTegProdDeployment/ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1be1756e"]])

export default __exports__